import React, { Component } from 'react'
import { observer, inject, Provider } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import Header from '../Common/Header'
import {
  DECORATION_JIA_MENG_GOODS,
  PRIVILEGE_STORE_ID,
  PRIVILEGE_STORE_SERVICE_ID,
  PROPERTY_OBJ,
  COLOR_BLUE
} from '@constant'
import { Auth } from '@common/Auth'
import Store from './store'
import Wedding from './Item/Wedding'
import Normal from './Item/Normal'
import style from './style.module.less'

@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
@inject('decorationStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.store.getList()
  }

  render() {
    const { list, total_count, fakeMode, fakeData } = this.store
    const { themeConfig, mode } = this.props.decorationStore
    let listData = fakeMode ? fakeData : list

    const showModule =
      mode === 'editable' || (mode === 'preview' && total_count > 0)

    return showModule ? (
      <Provider goodsStore={this.store}>
        <Rowbox
          type={DECORATION_JIA_MENG_GOODS}
          store={this.props.store}
          style={{
            flexDirection: 'column',
            height: 'auto',
            padding: 0,
            minHeight: 75,
            backgroundColor: 'initial'
          }}
          vCenter={false}
        >
          {listData.map(item => {
            const { property_id, kind } = item
            const isHunPin = kind == 2
            // 婚品和婚纱礼服样式类似，区别于其他类目
            const ListComp = isHunPin || property_id == 12 ? Wedding : Normal

            return (
              <div
                className={style.wrapper}
                key={property_id}
                style={{ backgroundColor: themeConfig['bg'] }}
              >
                <div className={style.list}>
                  <Header
                    title={isHunPin ? '婚品' : PROPERTY_OBJ[property_id]}
                  />
                  <ListComp {...item} />
                </div>

                <div
                  className={style.checkAll}
                  style={{
                    borderTop: `1px solid ${themeConfig['line']}`,
                    color: themeConfig['link'] || COLOR_BLUE
                  }}
                >
                  查看全部
                </div>
              </div>
            )
          })}
        </Rowbox>
      </Provider>
    ) : null
  }
}
